module.exports = __webpack_public_path__ + "static/media/khaadi.bfe88234.png";